import { render, staticRenderFns } from "./ShipSection.vue?vue&type=template&id=5dba8018&scoped=true"
import script from "./ShipSection.vue?vue&type=script&lang=js"
export * from "./ShipSection.vue?vue&type=script&lang=js"
import style0 from "./ShipSection.vue?vue&type=style&index=0&id=5dba8018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba8018",
  null
  
)

export default component.exports